class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.modal = document.getElementById("LocalizationModal");
    this.openBtn = document.querySelector(".js-open-localization");
    this.closeBtn = this.modal?.querySelector(".localization-modal__close");
    this.overlay = this.modal?.querySelector(".localization-modal__overlay");

    this.openBtn?.addEventListener("click", this.open.bind(this));
    this.closeBtn?.addEventListener("click", this.close.bind(this));
    this.overlay?.addEventListener("click", this.close.bind(this));
    document.addEventListener("keyup", this.onKeyUp.bind(this));

    // Detect groups with only 1 option (header/modal/mobile)
    this.setSingleGroups();
  }

  open(e) {
    e.preventDefault();
    if (!this.modal) return;

    this.modal.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    this.openBtn?.setAttribute("aria-expanded", "true");

    // Close any open dropdowns when modal opens (clean state)
    closeAllLocalizationDropdowns();
  }

  close() {
    if (!this.modal) return;

    this.modal.classList.add("hidden");
    document.body.style.overflow = "";
    this.openBtn?.setAttribute("aria-expanded", "false");

    closeAllLocalizationDropdowns();
  }

  onKeyUp(e) {
    if (e.key === "Escape") {
      // Escape closes dropdowns first, then modal
      closeAllLocalizationDropdowns();
      this.close();
    }
  }

  setSingleGroups() {
    document.querySelectorAll(".localization-group").forEach((group) => {
      const options = group.querySelectorAll(".localization-option");
      if (options.length <= 1) {
        group.classList.add("is-single");
      }
    });
  }
}

customElements.define("localization-form", LocalizationForm);

/**
 * Helpers
 */
function closeAllLocalizationDropdowns() {
  document
    .querySelectorAll(".localization-dropdown")
    .forEach((list) => list.classList.add("hidden"));

  document
    .querySelectorAll(".localization-group")
    .forEach((g) => g.classList.remove("is-open"));
}

function openLocalizationDropdown(group) {
  if (!group) return;

  const dropdown = group.querySelector(".localization-dropdown");
  if (!dropdown) return;

  // Close others first
  closeAllLocalizationDropdowns();

  dropdown.classList.remove("hidden");
  group.classList.add("is-open");
}

function toggleLocalizationDropdown(trigger) {
  const group = trigger.closest(".localization-group");
  if (!group) return;

  const dropdown = group.querySelector(".localization-dropdown");
  if (!dropdown) return;

  const isOpen = !dropdown.classList.contains("hidden");

  // Close all first
  closeAllLocalizationDropdowns();

  // If previously closed -> open it
  if (!isOpen) {
    dropdown.classList.remove("hidden");
    group.classList.add("is-open");
  }
}

function setTriggerLabel(triggerBtn, optionEl) {
  if (!triggerBtn || !optionEl) return;
  triggerBtn.innerHTML = optionEl.innerHTML + '<span class="chevron"></span>';
}

function setHiddenInputValue(group, name, value) {
  if (!group) return;
  const input = group.querySelector(`input[name="${name}"]`);
  if (input) input.value = value;
}

function findClosestForm(el) {
  return el?.closest("form");
}

/**
 * Main delegated click handler (works for modal, header, mobile menu)
 */
document.addEventListener("click", (e) => {
  const trigger = e.target.closest(".localization-dropdown-trigger");
  const option = e.target.closest(".localization-option");

  // 1) Trigger click -> toggle dropdown
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();

    // If this group is marked single option, don't open
    const group = trigger.closest(".localization-group");
    if (group?.classList.contains("is-single")) return;

    toggleLocalizationDropdown(trigger);
    return;
  }

  // 2) Option click -> set value + label + close dropdown
  if (option) {
    e.preventDefault();
    e.stopPropagation();

    const group = option.closest(".localization-group");
    if (!group) return;

    const dropdown = group.querySelector(".localization-dropdown");
    const triggerBtn = group.querySelector(".localization-dropdown-trigger");

    // Support both locale and country options
    if (option.dataset.locale) {
      setHiddenInputValue(group, "locale_code", option.dataset.locale);
      setTriggerLabel(triggerBtn, option);
    }

    if (option.dataset.country) {
      setHiddenInputValue(group, "country_code", option.dataset.country);
      setTriggerLabel(triggerBtn, option);
    }

    // Close dropdown after selecting
    dropdown?.classList.add("hidden");
    group.classList.remove("is-open");

    // OPTIONAL: auto-submit on selection if you want
    // const form = findClosestForm(group);
    // form?.submit();

    return;
  }

  // 3) Click outside -> close all dropdowns
  closeAllLocalizationDropdowns();
});

/**
 * Keyboard accessibility for dropdown trigger (Enter/Space)
 */
document.addEventListener("keydown", (e) => {
  const trigger = e.target.closest(".localization-dropdown-trigger");
  if (!trigger) return;

  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.stopPropagation();

    const group = trigger.closest(".localization-group");
    if (group?.classList.contains("is-single")) return;

    toggleLocalizationDropdown(trigger);
  }

  if (e.key === "Escape") {
    closeAllLocalizationDropdowns();
  }
});

/**
 * Mobile menu currency switcher support:
 * If your mobile menu opens dynamically (AJAX / drawer),
 * re-run "single group" detection when drawer is shown.
 *
 * This listens for a custom event if you have it,
 * and also runs once on DOMContentLoaded.
 */
function refreshLocalizationGroups() {
  document.querySelectorAll(".localization-group").forEach((group) => {
    const options = group.querySelectorAll(".localization-option");
    if (options.length <= 1) group.classList.add("is-single");
    else group.classList.remove("is-single");
  });
}

document.addEventListener("DOMContentLoaded", refreshLocalizationGroups);

// Fix flag SVG rendering in Safari: replace inline SVGs with <img> tags.
// Safari has known issues rendering SVG <pattern>+<use>+<image> structures.
document.addEventListener("DOMContentLoaded", function () {
  var xlink = "http://www.w3.org/1999/xlink";
  document.querySelectorAll(
    ".localization-dropdown-trigger svg, .localization-option svg"
  ).forEach(function (svg) {
    var imageEl = svg.querySelector("image");
    if (!imageEl) return;
    var src =
      imageEl.getAttributeNS(xlink, "href") || imageEl.getAttribute("href");
    if (!src) return;
    var img = document.createElement("img");
    img.src = src;
    img.width = parseInt(svg.getAttribute("width")) || 24;
    img.height = parseInt(svg.getAttribute("height")) || 16;
    img.style.cssText = "width:24px;height:16px;border-radius:2px;flex-shrink:0;display:block;";
    svg.parentNode.replaceChild(img, svg);
  });
});

/**
 * =========================
 * Mobile menu currency switcher (Shopify "disclosure")
 * Supports markup like:
 * - .disclosure__button.localization-selector
 * - .disclosure__list-wrapper [hidden]
 * - .disclosure__link[data-value]
 * - input[name="country_code"]
 * =========================
 */
(function initMobileDisclosureLocalization() {
  function closeAllMobileDisclosure(exceptWrapper = null) {
    document.querySelectorAll(".disclosure__list-wrapper").forEach((w) => {
      if (exceptWrapper && w === exceptWrapper) return;
      w.setAttribute("hidden", "");
      const disclosure = w.closest(".disclosure");
      const btn = disclosure?.querySelector(".disclosure__button");
      btn?.setAttribute("aria-expanded", "false");
    });
  }

  function openMobileDisclosure(wrapper, btn) {
    if (!wrapper || !btn) return;
    closeAllMobileDisclosure(wrapper);
    wrapper.removeAttribute("hidden");
    btn.setAttribute("aria-expanded", "true");
  }

  function toggleMobileDisclosure(btn) {
    const disclosure = btn.closest(".disclosure");
    const wrapper = disclosure?.querySelector(".disclosure__list-wrapper");
    if (!wrapper) return;

    const isOpen = !wrapper.hasAttribute("hidden");
    if (isOpen) {
      wrapper.setAttribute("hidden", "");
      btn.setAttribute("aria-expanded", "false");
    } else {
      openMobileDisclosure(wrapper, btn);
    }
  }

  // Delegated clicks (works even if drawer content is injected later)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".disclosure__button.localization-selector");
    const link = e.target.closest(".disclosure__link[data-value]");
    const closeBtn = e.target.closest(".disclosure__list__close");

    // 1) Open/close list
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileDisclosure(btn);
      return;
    }

    // 2) Close icon inside list
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const wrapper = closeBtn.closest(".disclosure__list-wrapper");
      const disclosure = closeBtn.closest(".disclosure");
      const triggerBtn = disclosure?.querySelector(".disclosure__button");
      wrapper?.setAttribute("hidden", "");
      triggerBtn?.setAttribute("aria-expanded", "false");
      return;
    }

    // 3) Pick an option
    if (link) {
      e.preventDefault();
      e.stopPropagation();

      const value = link.dataset.value; // country code like "AU", "US", etc.
      const disclosure = link.closest(".disclosure");
      const form = link.closest("form");
      const input = form?.querySelector('input[name="country_code"]');
      const wrapper = disclosure?.querySelector(".disclosure__list-wrapper");
      const triggerBtn = disclosure?.querySelector(".disclosure__button.localization-selector");

      if (input && value) input.value = value;

      // Update the visible label content to match chosen option
      // We reuse link inner markup (flag + text), but keep caret.
      if (triggerBtn) {
        const caret = triggerBtn.querySelector(".currency__caret");
        triggerBtn.innerHTML = link.innerHTML;
        if (caret) triggerBtn.appendChild(caret);
        triggerBtn.setAttribute("aria-expanded", "false");
      }

      // Close list
      wrapper?.setAttribute("hidden", "");

      // Submit localization form (Shopify expects submit)
      // This is usually required for country/currency to actually switch.
      form?.submit();
      return;
    }

    // 4) Click outside -> close all mobile disclosure lists
    // (Only if any is open)
    if (document.querySelector(".disclosure__list-wrapper:not([hidden])")) {
      closeAllMobileDisclosure();
    }
  });

  // ESC closes
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeAllMobileDisclosure();
  });
})();

/**
 * =========================
 * CA + USD auto-switch to CAD
 * If visitor is from CA and sees USD, automatically switch to CAD.
 * Skipped if the visitor has previously chosen a currency manually.
 * =========================
 */
(function initCadAutoSwitch() {
  const COOKIE_NAME = "ca_currency_chosen";
  const COOKIE_DAYS = 365;

  function getCookieValue(name) {
    const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/";
  }

  // If visitor has manually chosen a currency before, don't override
  if (getCookieValue(COOKIE_NAME)) return;

  // Auto-switch: form only exists in DOM for CA + USD visitors (rendered by Liquid)
  const autoForm = document.getElementById("CurrencyAutoSwitchForm");
  if (autoForm) {
    autoForm.submit();
    return;
  }

  // When a CA visitor manually submits the localization form, remember their choice
  // so we never auto-switch them again
  const localizationForm = document.getElementById("LocalizationForm");
  localizationForm?.addEventListener("submit", () => setCookie(COOKIE_NAME, "1", COOKIE_DAYS));

  // Mobile disclosure form submit (footer/mobile menu)
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form[action='/localization']");
    if (form && form.id !== "CurrencyAutoSwitchForm") {
      setCookie(COOKIE_NAME, "1", COOKIE_DAYS);
    }
  });
})();
